import React, { useEffect, useState } from 'react'
import './style.scss'
import { Icon } from 'react-icons-kit'
import { check } from 'react-icons-kit/feather'
import { Images } from '../../../utils/Images'
import Request from '../../../utils/Requests/Index'
import { toast } from 'react-toastify'

const Index = (props) => {

  const [loading, setLoading] = useState(false)
  const [header, setHeader] = useState(null)

  // SAFE destructuring (no crash)
  const {
    image,
    title,
    currency,
    finalCurrency,
    currencyType,
    type,
    durationType,
    duration,
    proposal = {},
    discountPercentage = 0
  } = props.data || {}

  // React 18 safe localStorage usage
  useEffect(() => {
    const token = localStorage.getItem('token')
    if (token) {
      setHeader({
        headers: { Authorization: `Bearer ${token}` }
      })
    }
  }, [])

  const surjoRequest = async (data) => {
    if (!header || loading) return

    try {
      setLoading(true)
      const res = await Request.Package.SurjoRequest(data, header)

      if (res?.link) {
        window.location.href = res.link
      } else {
        toast.error(res?.message || 'Something went wrong', {
          autoClose: 4000
        })
      }
    } catch (error) {
      toast.error('Server error. Please try again')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="card package-card border-0">
      <div className="card-body shadow-sm">

        <div className="image-container rounded-circle">
          <img
            src={image || Images.PackageSticker}
            className="img-fluid"
            alt="package"
          />
        </div>

        <br />

        <h5>{title}</h5>

        <div className="pricing mb-3">
          <h6>{type}</h6>

          {discountPercentage > 0 && (
            <h3 className="p-1">{discountPercentage}% off</h3>
          )}

          <h5 className={discountPercentage > 0 ? "p-1 cross text-dark" : "p-1"}>
            {currency} {currencyType}
          </h5>

          {discountPercentage > 0 && (
            <h5 className="p-1">
              {finalCurrency} {currencyType}
            </h5>
          )}

          <p>
            For {duration} {durationType === 'Day' ? 'day' : 'month'}
          </p>
        </div>

        <ul>
          <li>
            <p>
              <Icon icon={check} size={20} className="text-success mr-2" />
              Total proposal limit: {proposal?.totalLimit} person
            </p>
          </li>
          <li>
            <p>
              <Icon icon={check} size={20} className="text-success mr-2" />
              Contact view limit: {proposal?.contactViewLimit}
            </p>
          </li>
          <li>
            <p>
              <Icon icon={check} size={20} className="text-success mr-2" />
              Unlimited Messaging
            </p>
          </li>
        </ul>

        <div className="watermark" />

        <div className="text-end">
          <button
            type="button"
            className="btn shadow-sm rounded"
            disabled={loading}
            onClick={() => surjoRequest(props.data)}
          >
            {loading ? 'Requesting...' : 'Purchase Now'}
          </button>
        </div>

      </div>
    </div>
  )
}

export default Index
